import InputGroupComponent from './InputGroup.vue';
export const InputGroup = InputGroupComponent;
export default InputGroup;
